module.exports = __webpack_public_path__ + "6d60ef6fb159351239b569cbaa5a2d74.jpg";


//////////////////
// WEBPACK FOOTER
// ./public/content/assets/3000_9_teaser_image.jpg
// module id = 613
// module chunks = 0